import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

export const SET_PROVIDER_COMMISSION = 'app/CommissionPage/SET_PROVIDER_COMMISSION';

// ================ Reducer ================ //

const initialState = {
  providerCommission: 0,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_PROVIDER_COMMISSION:
      return {
        ...state,
        providerCommission: payload,
      };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setProviderCommission = payload => ({ type: SET_PROVIDER_COMMISSION, payload });

// ================ Thunks ================ //

const fetchCommission = (params, search, config) => (dispatch, getState, sdk) => {
  return sdk
    .assetsByAlias({ paths: ['transactions/commission.json'], alias: 'latest' })
    .then(response => {
      // Let's throw an error if we can't fetch commission for some reason
      const commissionAsset = response?.data?.data?.[0];
      if (!commissionAsset) {
        const message = 'Insufficient pricing configuration set.';
        const error = new Error(message);
        error.status = 400;
        error.statusText = message;
        error.data = {};
        throw error;
      }
      return response;
    });
};

export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  const promises = [dispatch(fetchCurrentUser()), dispatch(fetchCommission())];
  return Promise.all(promises).then(([_, fetchAssetsResponse]) => {
    const commissionAsset = fetchAssetsResponse.data.data[0];

    const {
      providerCommission: { percentage },
    } = commissionAsset?.type === 'jsonAsset' ? commissionAsset.attributes.data : {};

    dispatch(setProviderCommission(percentage));

    return true;
  });
};
